var map = {
	"./add1.svg": "bdbf",
	"./align-left.svg": "fb17",
	"./align-middle.svg": "2689",
	"./align-right.svg": "c56a9",
	"./allscreen.svg": "1a30",
	"./arrow-right.svg": "6929",
	"./b.svg": "9de2",
	"./banner.svg": "5544",
	"./btn.svg": "f68e",
	"./check.svg": "f75a",
	"./close.svg": "7710",
	"./component.svg": "56d6",
	"./dashboard.svg": "f782",
	"./drag.svg": "9bbf",
	"./edit-square-active.svg": "4df8",
	"./edit-square.svg": "6060",
	"./edit.svg": "aa46",
	"./edit1.svg": "128e",
	"./edit2-active.svg": "8403",
	"./edit2.svg": "4902",
	"./example.svg": "30c3",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./goods.svg": "7421",
	"./home_banner.svg": "0a8f",
	"./home_board.svg": "302a",
	"./home_info.svg": "3773",
	"./home_market.svg": "5545",
	"./home_menu.svg": "cf4d",
	"./home_star.svg": "0b33",
	"./img.svg": "9036",
	"./link.svg": "18f0",
	"./market.svg": "3338",
	"./move.svg": "2df4",
	"./nested.svg": "dcf8",
	"./password.svg": "2a3d",
	"./question.svg": "ae00",
	"./question2.svg": "e075",
	"./right.svg": "9a71",
	"./service_1.svg": "fd4a",
	"./service_2.svg": "ea5d",
	"./service_3.svg": "121f",
	"./service_4.svg": "be9e",
	"./service_5.svg": "5bf1",
	"./service_6.svg": "045c",
	"./table.svg": "47f1",
	"./textarea.svg": "128d",
	"./tree.svg": "93cd",
	"./unfold-less.svg": "3eee",
	"./unfold-more.svg": "783d",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";